const MODULE_NAME = 'ReportsModule';

export const REPORTS_TOGGLE_EXCLUDE_ITEMS = `${MODULE_NAME}/TOGGLE_EXCLUDE_ITEMS`;
export const REPORTS_ITEM_TO_EXCLUDE = `${MODULE_NAME}/ITEM_TO_EXCLUDE`;
export const REPORTS_TOGGLE_INTERNAL_REPORT = `${MODULE_NAME}/TOGGLE_INTERNAL_REPORT`;
export const REPORTS_GET_REPORT_VIEW = `${MODULE_NAME}/GET_REPORT_VIEW`;
export const REPORTS_UPDATE_ATTACHMENT_IMAGE = `${MODULE_NAME}/UPDATE_ATTACHMENT_IMAGE`;
export const REPORTS_DELETE_REVISION = `${MODULE_NAME}/DELETE_REVISION`;
export const REPORTS_UPDATE_CUSTOMER_OUT_OF_TOLERANCE = `${MODULE_NAME}/UPDATE_CUSTOMER_OUT_OF_TOLERANCE`;
export const REPORTS_EXPORT_TASK = `${MODULE_NAME}/EXPORT_TASK`;
